import {useState} from 'react';

import AttachFileIcon from '@mui/icons-material/AttachFile';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';

import {useGetFilesQuery} from '../../redux/services/fileApi';

const ClaimFileDownloadButton = props => {
  const { claim: c } = props;
  const [clicked, setClicked]  = useState(false);
  const shouldSkipQuery = !c?.eob_file?.id || !clicked;
  const patientFileQuery = useGetFilesQuery({
    id: c?.eob_file?.id,
    include_hidden_files: true,
  }, {skip: shouldSkipQuery});
  const url = patientFileQuery?.data?.data?.[0]?.url;
  return (
    <IconButton
    variant={url ? 'contained' : 'outlined'}
    color={url ? 'success' : 'primary'}
    href={url}
    target={url ? '_blank' : null}
    onClick={!url ? () => setClicked(true) : null}
  >
    {
      url
      ? <DownloadIcon/>
      : <AttachFileIcon />
  }
  </IconButton>
  );
};

export default ClaimFileDownloadButton;